import type { User } from '@ztechapps/common.contract'

/**
 * The shared option label for the customer, vendor and contact pickers:
 * the company name followed by the contact name in parentheses.
 * A missing segment collapses, taking its separator with it.
 *
 * @param user - The option or user carrying `company.name` and `profile.name`
 * @returns The label react-select renders for the option
 */
export function buildUserSelectLabel(user?: Partial<User> | null): string {
  const name = user?.profile?.name
  return [user?.company?.name, name ? `(${name})` : undefined].filter(Boolean).join(' - ')
}
